<template>
  <form @submit.prevent="onFormSubmit">
    <NotificationBar v-if="hasFormError()" type="error">
      <NotificationBarTitle>{{formErrorMessage()}}</NotificationBarTitle>
      <slot name="errorMessage" />
    </NotificationBar>
    <NotificationBar v-if="hasFormSuccess()" type="success">
      <NotificationBarTitle>{{formSuccessMessage()}}</NotificationBarTitle>
      <slot name="successMessage" />
    </NotificationBar>
    <slot/>
  </form>
</template>

<script>
import formField from '@/mixins/formField'

export default {
  name: "FormGroup",
  mixins: [formField],
  props: {
    form: Object,
    labelColumnSize: {
      type: Number,
      default: 2
    },
  },
  methods: {
    hasFormError() {
      return (this.$props.form != undefined && this.$props.form.errorMessage != undefined)
    },
    formErrorMessage() {
      if(this.$props.form != undefined && this.$props.form.errorMessage != undefined)
        return this.$props.form.errorMessage
      return ''
    },
    hasFormSuccess() {
      return (this.$props.form != undefined && this.$props.form.successMessage != undefined)
    },
    formSuccessMessage() {
      if(this.$props.form != undefined && this.$props.form.successMessage != undefined)
        return this.$props.form.successMessage
      return ''
    },
    onFormSubmit(ev) {
      this.$emit('submit', ev)
    }
  }

}
</script>
